<template>
  <div class="interaction" :class="{'outInteraction': isSingle=='1'}">
    <h3 v-if="isSingle=='1'">聊天室</h3>
    <el-row :gutter="10">
      <el-col :span="16">
        <div class="chatBox" id="chatRoom">
          <ul>
            <li class="clearfix" :class="{'others': !chat.lecturer, 'me': chat.lecturer}" v-for="(chat, index) in chatList" :key="index">
              <div class="avatar">
                <img
                  :src="chat.imageUrl"
                />
              </div>
              <div class="clearfix content">
                <div class="name">
                  {{ chat.name }}
                  {{ chat.lecturer ? '(讲师)' : '' }}
                </div>
                <span class="text">
                  {{ chat.content }}
                </span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 暂时不要这些功能
        <div class="toolLine">
          <div class="left">
            <span @click="openVote">投票</span>
            <span @click="openAnswer">答题</span>
            <span @click="openRedPocket">红包</span>
          </div>
          <div class="right">
            2位学员反馈: 讲课速度快 | 6位学员反馈: 讲课声音小
            <el-button type="text">我知道了</el-button>
          </div>
        </div>-->
        <div class="enter">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="输入聊天文字..."
            v-model="chatContent">
          </el-input>
          <div class="btnBox">
            <router-link
              v-if="isSingle!=='1'"
              :to=" { path:'/chatRoom', query:{id: courseId, isSingle: 1} }" target="_blank"
            >
              <el-button
                class="btn"
                :style="{
              color: '#fff',
              background: '#1abc9c',
            }"
              >在新页面打开</el-button>
            </router-link>
            <el-button
              @click="exportLog"
              plain
            >导出历史记录</el-button>
            <el-button
              @click="doSend"
              class="btn"
              :style="{
              color: '#fff',
              background: '#1abc9c',
            }"
            >发送</el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="detailText">
          {{ courseName }}
        </div>
        <div class="currentTime">当前时间: {{ currentTime }}</div>
        <div class="nameCard">
          <div class="person">
            <div class="avatar">
              <img :src="lecturerAvatar" />
            </div>
            <div class="personDetail">
              <div class="name">{{ this.lecturerName }}</div>
              <div class="title">{{ this.lecturerRole }}</div>
            </div>
          </div>
          <div class="personDesc">
            {{ this.lecturerIntroduce }}
          </div>
        </div>
        <el-card class="randomSelect">
          <el-button
            @click="openSetSelectNum"
            class="btn"
            :style="{
              color: '#fff',
              background: '#1abc9c',
            }"
          >随机抽选器</el-button>
        </el-card>
        <div class="answerBox">
          <p>答题 {{ answerNumber }}</p>
          <ul>
            <li v-for="(answer, index) in answerList" :key="index">
              <div class="left">
                <p>答题类型: {{ answer.typeStr }}</p>
                <p>{{ answer.titleGroup }}</p>
              </div>
              <div class="right">
                <div>
                  <el-button
                    v-if="!answer.isAnswerRecordDisplay"
                    @click="pushQuestion(answer.answerId)"
                    class="btn"
                    :style="{
                    color: '#fff',
                    background: '#1abc9c',
                  }"
                  >推送</el-button>
                  <el-button
                    v-if="answer.isAnswerRecordDisplay"
                    plain
                    disabled
                    @click="pushQuestion(answer.answerId)"
                  >推送</el-button>
                  <el-button
                    v-if="answer.isAnswerRecordDisplay"
                    @click="seeLog(answer.answerId, answer.typeStr)"
                    class="btn"
                    :style="{
                    color: '#fff',
                    background: '#1abc9c',
                    marginLeft: '0px'
                  }"
                  >查看记录</el-button>
                </div>
                <div style="text-align: center" v-if="!!answer.answeringStr">
                  <span>作答中...</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

      </el-col>
    </el-row>
    <el-dialog
      title="随机抽选器设置"
      :visible.sync="setSelectNum"
      width="30%"
    >
      <div class="selectContainer">

        <el-form ref="form" :model="selectForm" label-width="160px">
          <el-form-item label="随机抽选学员数量">
            <el-input-number
              v-model="selectForm.selectNum"
              :min="1"
              :max="5"
            >
              <template slot="append">名</template>
            </el-input-number>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setSelectNum = false">取 消</el-button>
        <el-button
          type="primary"
          @click="openSelectStudent"
          :style="{
              color: '#fff',
              background: '#1abc9c',
          }"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="selectStudent"
      width="96%"
      custom-class="selectDialog"
    >
      <div class="dialogContainer">
        <div class="selectBackground"
          :style="{backgroundImage: 'url(./static/icons/select_background.png)'}"
        >
          <div class="layer">
            <ul :style="{visibility: showLayer ? 'visible' : 'hidden'}">
              <li
                v-for="index in selectForm.selectNum" :key="index"
                :style="{backgroundImage: 'url(./static/icons/logo.png)'}"
              >

              </li>
            </ul>
          </div>
          <div class="selectList">
            <div
              class="selectBox"
              v-for="index in selectForm.selectNum"
              :key="index"
            >
              <SlotMachine
                ref="slotMachine"
                width="240px"
                height="240px"
                :prizes="prizesArray[index - 1]"
                :blocks="blocks"
                :slots="getSlots()"
                @end="endCallback"
                :defaultConfig="defaultConfig"
              />
              <!--
              <div class="rePick">
                <span
                  v-if="!isFirstSelect"
                  @click="reSelect(index - 1)"
                  :disable="disableSelect"
                >
                  重抽
                </span>
              </div>-->
            </div>
          </div>

        </div>
      </div>
      <div style="margin-top: 10px; margin-left: auto; margin-right: auto; width: 1410px"><el-checkbox v-model="excludeStudent" size="medium"><span style="verticalAlign: -3px; fontSize:24px; color: #fff">排除已抽选学员</span></el-checkbox></div>
      <div class="startPick" style="margin-top: -20px">
        <button
          @click="startSelect"
          :disabled="disableSelect"
          class="startSelect"
        >
          抽选
        </button>
        <!--
        <el-button
          :style="{
          color: '#fff',
          background: '#1abc9c',
        }"
          v-if="!isFirstSelect"
          @click="reSelectAll"
          :disable="disableSelect"
        >
          重新抽选
        </el-button>-->
        <div style="margin-top: 20px; color: #fff; fontSize: 24px">(抽取范围: 已签到人员)</div>
        <div style="margin-top: 30px" @click="closeSelect">
          <img src="../../../../../static/icons/close.png" alt="" style="width: 40px">
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="当前投票统计"
      :visible.sync="voteStatistics"
      width="30%"
    >
      <div class="voteStatisticsContainer">
        投票倒计时: 00:06:32
        <ul class="votes">
          <li>
            <p>A: 投票选项1</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>C: 投票选项3</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>B: 投票选项2</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>G: 投票选项7</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>A: 投票选项1</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>C: 投票选项3</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>B: 投票选项2</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>G: 投票选项7</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>A: 投票选项1</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>C: 投票选项3</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>B: 投票选项2</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
          <li>
            <p>G: 投票选项7</p>
            <div>
              <span class="bar" style="width: 20%"></span>
              <span class="number">11票(20%)</span>
            </div>
          </li>
        </ul>


      </div>
    </el-dialog>
    <el-dialog
      title="当前答题统计"
      :visible.sync="answerStatistics"
      width="30%"
    >
      <div class="answerStatisticsContainer">
        <div class="slideContainer">
          <VueSlickCarousel :arrows="true" :dots="false">
            <div class="question">
              <p>1.题目: 文字描述文字描述</p>
              <ul class="answers">
                <li>
                  <p>1.选项一</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
                <li>
                  <p>2.选项二</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
                <li>
                  <p>3.选项三</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
                <li>
                  <p>4.选项四</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="question">
              <p>2.题目: 文字描述文字描述</p>
              <ul class="answers">
                <li>
                  <p>1.选项一</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="question">
              <p>3.题目: 文字描述文字描述</p>
              <ul class="answers">
                <li>
                  <p>1.选项一</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="question">
              <p>4.题目: 文字描述文字描述</p>
              <ul class="answers">
                <li>
                  <p>1.选项一</p>
                  <div>
                    <span class="bar" :style="styleObject(64)"></span>
                    <span class="number">64%</span>
                  </div>
                </li>
              </ul>
            </div>
          </VueSlickCarousel>
        </div>
        <el-divider></el-divider>
        <div class="awardsStatistics">
          <p>获奖统计</p>
          <div class="awardsContainer">
            <ul>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
              <li>
                <span class="name">1. 张三</span>
                <span class="time">36秒</span>
                <span class="score">60分</span>
              </li>
            </ul>
          </div>
        </div>


      </div>
    </el-dialog>
    <el-dialog
      title="当前红包统计"
      :visible.sync="redPocketStatistics"
      width="30%"
    >
      <div class="redPocketStatisticsContainer">
        <div class="question">
          <p>1.题目: 文字描述文字描述</p>
          <ul class="answers">
            <li>
              <p>1.选项一</p>
              <div>
                <span class="bar" :style="styleObject(64)"></span>
                <span class="number">64%</span>
              </div>
            </li>
            <li>
              <p>2.选项二</p>
              <div>
                <span class="bar" :style="styleObject(64)"></span>
                <span class="number">64%</span>
              </div>
            </li>
            <li>
              <p>3.选项三</p>
              <div>
                <span class="bar" :style="styleObject(64)"></span>
                <span class="number">64%</span>
              </div>
            </li>
            <li>
              <p>4.选项四</p>
              <div>
                <span class="bar" :style="styleObject(64)"></span>
                <span class="number">64%</span>
              </div>
            </li>
          </ul>
        </div>
        <el-divider></el-divider>
        <div class="awardsStatistics">
          <p>获奖统计</p>
          <div class="awardsContainer">
            <ul>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
              <li>
                <span class="name">1. 上海-sanse-王文</span>
                <span class="time">6秒</span>
                <span class="score">获得奖品</span>
              </li>
            </ul>
          </div>
        </div>


      </div>
    </el-dialog>
    <el-dialog
      title="答题记录"
      :visible.sync="answerLogDialog"
      width="80%"
    >
      <div v-if="noAnswer">
        没有答题记录
      </div>
      <div v-if="!noAnswer">
        <div class="tabRight">
          <el-button
            @click="exportAnswerLog"
            plain
          >
            导出答题记录
          </el-button>
        </div>
        <div class="tabContainer">
          <div class="tabLeft">
            <el-tabs v-model="activeTime" type="card" @tab-click="handleTimeChange">
              <el-tab-pane
                :label="time.pushingTimeStr"
                :name="time.pushingTime"
                v-for="(time, index) in answerTimes"
                :key="index"
              >
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="question">
          <div class="questionIndex">
            <span><em>{{ answerQuestionIndex }}</em>/{{ answerQuestionAll }}</span>
          </div>
          <p class="groupTitle">{{ titleGroup }}</p>
          <p class="questionTitle">{{ answerQuestionIndex }}. 题目: {{ answerQuestionName }}</p>
          <ul class="answers">
            <li v-for="(item, i) in answerItems" :key="i">
              <p>{{ item.serialNumber }}. {{ item.content }}</p>
              <div class="barBox">
                <span class="bar" :style="'width: ' + item.accuracy + '%'"></span>
                <span class="number">{{ item.accuracy }}%</span>
              </div>
            </li>
          </ul>
          <div style="text-align: center">
            <el-button
              :style="{
              color: '#fff',
              background: '#1abc9c',
            }"
              v-if="answerQuestionIndex != 1"
              @click="prevQuestion">
              上一题
            </el-button>
            <el-button
              :style="{
              color: '#fff',
              background: '#1abc9c',
            }"
              v-if="answerQuestionIndex != answerQuestionAll"
              @click="nextQuestion">
              下一题
            </el-button>
          </div>
        </div>

        <el-divider></el-divider>
        <el-table
          :data="answerTable"
          style="width: 100%"
          @sort-change="sortHandler"
        >
          <el-table-column
            prop="regionName"
            label="区域"
          >
          </el-table-column>
          <el-table-column
            prop="provinceName"
            label="省份"
          >
          </el-table-column>
          <el-table-column
            prop="cityName"
            label="城市">
          </el-table-column>
          <el-table-column
            prop="resellerName"
            label="客户"
          >
          </el-table-column>
          <el-table-column
            prop="subReseller"
            label="二级客户"
          >
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="角色"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="用户名">
          </el-table-column>
          <el-table-column
            prop="cellphone"
            label="手机号"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="totalTimeStr"
            label="答题时长"
            sortable="custom"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="answerResult"
            label="答题结果"
            sortable="custom"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="awardInformation"
            label="获奖信息"
            v-if="showAwardInformation"
          >
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :current-page="answerCurrent"
            :total="answerTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SockJS from  'sockjs-client';
import Stomp from 'stompjs';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import _ from "lodash";
import Cookies from "js-cookie";
export default {
  components: { VueSlickCarousel },
  data (){
    return {
      disableSelect: false, // 是否可以重抽
      noAnswer: false,
      isSingle: this.$route.query.isSingle,
      token: Cookies.get('token'),
      stompClient: '',
      socketTimer: null,
      timer: '',
      socket: '',
      courseId: this.$route.query.id, // 课程id
      chatContent: '', // 输入的聊天内容
      chatList: [], //
      selectForm: {
        selectNum: 1, // 随机抽选学生数量
      },
      setSelectNum: false, // 设置抽选学生数量弹窗
      selectStudent: false, // 抽选学生弹窗
      voteStatistics: false, // 投票统计弹窗
      answerStatistics: false, // 当前答题统计弹窗
      redPocketStatistics: false, // 红包统计弹窗
      answerLogDialog: false, // 答题记录弹窗
      blocks: [
        {
          padding: '0',
          background: '#1EBC9D',
        },
      ],
      basePrizes: [], // 每个老虎机里都有的基础奖池(10个没有被抽中的学生名单)
      prizesArray: [], // 各个老虎机里的奖池
      pickedResult: [], // 抽选的学生
      showLayer: true, // 显示抽奖的问号
      isFirstSelect: true, // 是否第一次抽奖
      excludeStudent: false, // 是否排除已抽选学员
      defaultConfig: {
        rowSpacing: '0',
        colSpacing: '0'
      },
      courseName: '', // 课程名称
      lecturerName: '', // 讲师姓名
      lecturerRole: '', // 讲师角色
      lecturerIntroduce: '', // 讲师介绍
      lecturerAvatar: '', // 讲师头像
      currentTime: '', // 当前时间
      curQuestions: [], // 当前时间对应的题目列表
      answerQuestionIndex: '', // 答题的当前索引
      answerQuestionAll: '', // 答题的总数
      answerNumber: '0/0', // 答题的完成/总数
      answerList: [], // 右侧回答问题列表
      activeTime: '', // 当前选择的答题记录时间
      answerTimes: [], // 答题记录时间集
      answerCurrent: 1, // 答题记录列表的分页
      answerTotal: 1, // 答题记录列表的总数
      answerTable: [], // 答题记录里的表格
      showAwardInformation: false, // 表格里是否显示'获奖信息'这一栏
      answerId: '', // 当前查看答题记录的id
      answerQuestionId: '', // 当前答题记录当前题目的id
      titleGroup: '', // 查看答题记录当前答题的题目组名称
      answerQuestionName: '', // 查看答题记录当前题目的名称
      answerItems: '', // 查看答题记录当前答题的题目的选项
      orderItem: [], // 表格排序
    }
  },
  mounted (){
    this.token = Cookies.get('token')
    this.getStudentsList()
    this.getRightInfo()
    this.setCurrentTime()
    this.init()
  },
  methods: {
    closeSelect () {
      this.selectStudent = false
    },
    openNew () {
      this.$router.push('/chatRoom')
    },
    /*********************socket相关方法start**********************/
    init () {
      this.connection().then(this.connectCallback).catch(this.errorCallback);
    },
    connection () {
      console.log("开始连接....")
      // 向服务器发起websocket连接
      const _this = this
      var promise = new Promise(function (resolve, reject) {

        let baseUrl
        const domain = window.location.origin
        // if (domain=== 'uat-nikegetit2.nike.com') {
        //   baseUrl = "https://uat-nikegetit2.nike.com/elearning-offline-courses"
        // } else if (domain=== 'uat-nikegetit2.nike.com.cn' || _.startsWith(domain, '127.0.0.1')) {
        //   baseUrl = "https://uat-nikegetit2.nike.com.cn/elearning-offline-courses"
        // } else if(domain=== 'nikegetit2.nike.com'){
        //   baseUrl = "https://nikegetit2.nike.com/elearning-offline-courses"
        // } else if(domain=== 'nikegetit2.nike.com.cn'){
        //   baseUrl = "https://nikegetit2.nike.com.cn/elearning-offline-courses"
        // }else{
        //   baseUrl = offlineCourse;
        // }
        baseUrl = domain+"/elearning-offline-courses"
        console.log('baseUrl', baseUrl)

        _this.socket = new SockJS(baseUrl + "/ws") //协议字段

        // let baseUrl = offlineCourse;
        // _this.socket = new SockJS(baseUrl+"/ws") //协议字段

        _this.stompClient = Stomp.over(_this.socket)

        var headers = {
          token: _this.token,
          courseId: _this.courseId,
          cursorId: 0
        };

        _this.stompClient.connect(headers, function (frame) {
          console.log('消息服务连接成功')
          resolve(_this.stompClient);
        }, function (error) {
          console.log('错误断开', error)
          // 监听报错信息，手动发起重连
          if (_this.socketTimer) {
            clearInterval(_this.socketTimer)
          }
          // 1s后重新连接一次
          _this.socketTimer = setTimeout(() => {
            console.log("开始重联")
            _this.init();
          }, 1000);

          reject(error)
        });
      });
      return promise;
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect()
      }
    },

    connectCallback (stomp) {
      var _this = this
      stomp.subscribe('/app/historyMessage/' + _this.courseId + '/' + 0, function (message) {
        var json = JSON.parse(message.body)
        console.log('历史消息 message:', json);
        _this.chatList = json
        setTimeout(() => {_this.scrollToBottom()}, 200)
      },{'token': _this.token, deviceType: 'WEB'});

      stomp.subscribe("/topic/chat/" + _this.courseId, function (message) {
        var json = JSON.parse(message.body)
        console.log("收到新消息：", json);
        _this.chatList.push(json)
        setTimeout(() => {_this.scrollToBottom()}, 200)
      });

      stomp.subscribe("/topic/answer/" + _this.courseId, function (message) {
        var json = JSON.parse(message.body)
        console.log("收到答题消息：", json);
      });

      stomp.subscribe("/topic/answerEnd/" + _this.courseId, function (message) {
        var json = JSON.parse(message.body)
        console.log("收到答题结束消息：", json);
        let answerEndId = json.answerId // 结束答题的题目id
        _.each(_this.answerList, (answer) => {
          if (answer.answerId == answerEndId) {
            answer.answeringStr = ''
            console.log('answer', answer)
          }
        })
        _this.answerList = _.cloneDeep(_this.answerList)
      });
    },
    doSend () {
      var payload = JSON.stringify({ 'to': this.courseId, 'content': this.chatContent });
      this.stompClient.send("/app/chat", {token: this.token}, payload);
      this.chatContent = ''
    },
    // 导出聊天记录
    async exportLog () {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: offlineCourse + "/course/historyMessageExport/" + this.courseId,
      });
    },
    errorCallback () {
      console.log('连接失败')
    },
    // 让聊天室滚动到底部
    scrollToBottom() {
      var element = document.getElementById("chatRoom");
      element.scrollTop = element.scrollHeight;
    },
    /*********************socket相关方法end**********************/

    // 设置当前时间
    setCurrentTime() {
      setInterval(() => {
        let timeObj = new Date()
        let timeDetail = timeObj.toString().split(' ')[4]
        let year = timeObj.toString().split(' ')[3]
        let month = timeObj.getMonth()+1
        let date = timeObj.getDate()
        this.currentTime = year + '-' + month + '-' + date + ' ' + timeDetail
      }, 1000)
    },
    // 打开投票弹窗
    openVote() {
      this.voteStatistics = true
    },
    // 打开当前答题统计弹窗
    openAnswer() {
      this.answerStatistics = true
    },
    // 打开当前红包统计弹窗
    openRedPocket() {
      this.redPocketStatistics = true
    },

    styleObject (percent) {
      return {
        width: percent + '%'
      }
    },

    // 推送答题
    async pushQuestion (answerId) {
      let res = await axios.post(`/offline-course/course/pushAnswer/` + answerId);
      if (res.data.code === 200 && res.data.success) {
        this.$message.success(res.data.message)
        this.getRightInfo()
      }
    },

    // 答题查看记录
    async seeLog (answerId, answerType) {
      this.answerId = answerId
      const answerTimes = await this.getAnswerTimes(answerId)
      if (!answerTimes.length) {
        // 没有答题记录
        this.noAnswer = true
        this.answerLogDialog = true
        return false
      } else {
        this.noAnswer = false
        // pushingTime需要是字符串
        _.each(answerTimes, (answerTime) => {answerTime.pushingTime = _.toString(answerTime.pushingTime)})
        this.answerTimes = answerTimes
        this.activeTime = this.answerTimes[0].pushingTime
        const question = await this.getTimeQuestions(answerId, this.answerTimes[0].pushingTime)
        console.log('question', question)
        this.curQuestions.push(question)
        this.resetCurrentQuestion(question)
        this.answerCurrent = 1
        const answerTable = await this.getAnswerTable(answerId, this.answerTimes[0].pushingTime)
        console.log('answerTable', answerTable)
        this.answerTable = answerTable.records
        this.answerTotal = answerTable.total
        this.showAwardInformation = answerType === '红包答题'
        this.answerLogDialog = true
      }

    },

    // 更新当前查看的答题题目
    resetCurrentQuestion (question) {
      this.answerQuestionIndex = question.currentOrAllCount.split('/')[0]
      this.answerQuestionAll = question.currentOrAllCount.split('/')[1]
      this.titleGroup = question.titleGroup
      this.answerQuestionName = question.answerQuestionName
      this.answerItems = question.items
      this.answerQuestionId = question.answerQuestionId
    },

    // 获取答题时间集
    async getAnswerTimes (answerId) {
      let res = await axios.post('/offline-course/course/answerRecordDate/' + answerId);
      if (res.data.code === 200 && res.data.success) {
        console.log('查看记录的时间集', res.data)
        return res.data.data
      } else {
        return false
      }
    },

    // 通过时间获取对应的题目
    async getTimeQuestions (answerId, time) {
      let res = await axios.post('/offline-course/course/answerRecordQuestion/', {
        answerId: answerId,
        answerQuestionId: 0,
        pushingTime: time
      });
      if (res.data.code === 200) {
        console.log('通过时间请求题目', res.data)
        return res.data.data
      } else {
        return false
      }
    },

    // 获取下一题题目
    async getNextQuestions () {
      let res = await axios.post('/offline-course/course/answerRecordQuestion/', {
        answerId: this.answerId,
        answerQuestionId: this.answerQuestionId,
        pushingTime: this.activeTime
      });
      if (res.data.code === 200) {
        console.log('下一题题目', res.data)
        return res.data.data
      } else {
        return false
      }
    },

    // 通过时间获取对应的答题记录列表
    async getAnswerTable (answerId, time) {
      let res = await axios.post('/offline-course/course/answerRecordList/', {
        answerId: answerId,
        current: this.answerCurrent,
        pushingTime: time,
        orderItem: this.orderItem || []
      });
      if (res.data.code === 200) {
        console.log('通过时间请求答题列表', res.data)
        return res.data.data
      } else {
        return false
      }
    },

    // 上一题
    prevQuestion () {
      // 删除最后一个题目
      this.curQuestions.pop()
      console.log('this.curQuestions', this.curQuestions)
      this.resetCurrentQuestion(this.curQuestions[this.curQuestions.length - 1])
    },

    // 下一题
    async nextQuestion () {
      const question = await this.getNextQuestions()
      this.resetCurrentQuestion(question)
      this.curQuestions.push(question)
      console.log('question', question)
    },

    // 答题记录时间切换
    async handleTimeChange () {
      this.curQuestions = []
      const question = await this.getTimeQuestions(this.answerId, this.activeTime)
      console.log('question', question)
      this.curQuestions.push(question)
      this.resetCurrentQuestion(question)
      const answerTable = await this.getAnswerTable(this.answerId, this.activeTime)
      console.log('answerTable', answerTable)
      this.answerCurrent = 1;
      this.answerTable = answerTable.records
      this.answerTotal = answerTable.total
    },

    // 答题记录分页切换
    async currentChange (index) {
      console.log('index.........', index)
      this.answerCurrent = index;
      const answerTable = await this.getAnswerTable(this.answerId, this.activeTime)
      this.answerTable = answerTable.records
      this.answerTotal = answerTable.total
    },

    // 导出答题记录
    async exportAnswerLog () {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: offlineCourse + "/course/exportAnswerRecord/" + this.answerId,
      });
    },

    // 获取聊天室右侧的数据
    async getRightInfo () {
      let res = await axios.post(`/offline-course/course/chatBoxRightData/` + this.courseId);
      if (res.data.code === 200) {
        console.log('右侧的数据', res.data)
        // 讲师和课程名字
        this.lecturerName = res.data.data.name
        this.lecturerRole = res.data.data.title
        this.lecturerIntroduce = res.data.data.introduce
        this.lecturerAvatar = res.data.data.imageUrl
        this.courseName = res.data.data.courseName
        // 答题列表
        this.answerNumber = res.data.data.numberCompletionsOrAllCount
        this.answerList = res.data.data.answerList
      }
    },

    async sortHandler(item){
      let {prop,order} = item;
      if(order){
        this.orderItem = [{
          asc: order === 'ascending',
          column: prop
        }]
        this.answerCurrent = 1
      }

      if(!order){
        delete this.orderItem;
      }

      // todo:
      const answerTable = await this.getAnswerTable(this.answerId, this.activeTime);
      this.answerTable = answerTable.records
      this.answerTotal = answerTable.total
    },

    /*********************老虎机相关方法start**********************/
    // 获取抽取的学生列表
    async getStudentsList () {
      let res = await axios.post(`/offline-course/course/sweepstakesPreloadData/` + this.courseId);
      if (res.data.code === 200) {
        console.log('抽选的学生列表', res.data)
        let students = res.data.data.slice(0, 10)
        _.each(students, (student) => {
          this.basePrizes.push(this.formatStudent(student))
        })
      }
    },
    // 给每个老虎机生成抽奖的速度
    getSlots () {
      var speed = _.random(12, 20);
      return [
        {speed: speed}
      ]
    },
    // 打开设置抽选人数弹窗
    openSetSelectNum () {
      this.setSelectNum = true
    },
    // 打开抽选学生弹窗
    async openSelectStudent () {
      this.setSelectNum = false
      this.selectForm.selectNum = _.toNumber(this.selectForm.selectNum)
      this.showLayer = true
      this.selectStudent = true
      this.isFirstSelect = true
    },
    // 从服务器抽取学生
    async pickStudent (number) {
      let res = await axios.post(`/offline-course/course/sweepstakes/`,
        {
          count: number,
          courseId: this.courseId,
          exclude: this.excludeStudent
        }
      );
      if (res.data.code === 200) {
        console.log('抽奖结果', res.data.data)
        let pickedStudents = res.data.data
        _.each(pickedStudents, (student) => {
          // this.basePrizes.push(this.formatStudent(student))
          this.pickedResult.push(student.sweepstakesRecordId)
        })
        console.log('this.basePrizes', this.basePrizes)
        for(let i = 0; i < number ; i++) {
          this.prizesArray.push(_.cloneDeep(this.basePrizes))
        }
        for(let i = 0; i < number ; i++) {
          this.prizesArray[i].push(this.formatStudent(pickedStudents[i]))
        }
        return true
        console.log('this.prizesArray', this.prizesArray)
      } else {
        setTimeout(() => {
          this.disableSelect = false
        }, 3000)
        return false
      }
    },
    // 从服务器抽取学生(单个重抽)
    async rePickStudent (index) {
      let res = await axios.post(`/offline-course/course/repeatSweepstakes/`,
        {
          "courseId": this.courseId,
          "exclude": this.excludeStudent,
          "sweepstakesRecordIds": [this.pickedResult[index]]
        }
      );
      if (res.data.code === 200) {
        console.log('重抽结果', res.data.data)
        let pickedStudent = res.data.data[0]
        this.pickedResult[index] = pickedStudent.sweepstakesRecordId
        return pickedStudent
      }
    },
    // 从服务器抽取学生(全部重抽)
    async rePickAllStudent () {
      let res = await axios.post(`/offline-course/course/repeatSweepstakes/`,
        {
          "courseId": this.courseId,
          "exclude": this.excludeStudent,
          "sweepstakesRecordIds": this.pickedResult
        }
      );
      if (res.data.code === 200) {
        console.log('重抽结果', res.data.data)
        let pickedStudents = res.data.data
        this.pickedResult = []
        _.each(pickedStudents, (student) => {
          this.pickedResult.push(student.sweepstakesRecordId)
        })
        return pickedStudents
      }
    },
    // 把student转换为老虎机prizes需要的格式
    formatStudent (student) {
      return {
        fonts: [
          {
            text: student.name,
            top: 180,
            fontSize: 32,
            fontColor: '#fff'

          },
        ],
        imgs: [
          {
            top: 20,
            src: student.imageUrl,
            height: 150,
            width: 150,
          },
          {
            top: 20,
            src: '../../../../static/icons/layer.png',
            height: 150,
            width: 150,
          }
        ],
        background: '#1EBC9D',
        borderRadius: 10,
      }
    },
    // 开始抽奖
    async startSelect () {
      this.disableSelect = true
      this.isFirstSelect = false
      if (await this.pickStudent(this.selectForm.selectNum)) {
        this.showLayer = false
        for (var i = 0 ; i < this.selectForm.selectNum ; i++) {
          this.startCallback(i)
        }
      }
    },
    // 重抽(全部)
    async reSelectAll() {
      let rePickedStudents = await this.rePickAllStudent()
      for(let i = 0; i < this.selectForm.selectNum ; i++) {
        this.prizesArray[i].push(this.formatStudent(rePickedStudents[i]))
      }
      for (var i = 0 ; i < this.selectForm.selectNum ; i++) {
        this.startCallback(i)
      }
    },
    // 重抽(单个)
    async reSelect(i) {
      let rePickedStudent = await this.rePickStudent(i)
      this.prizesArray[i].push(this.formatStudent(rePickedStudent))
      this.startCallback(i)
    },
    // 转动老虎机
    startCallback (i) {
      // slotMachine
      this.$nextTick(function () {// 调用$nextTick函数
        this.$refs['slotMachine'][i].play()
        // 模拟调用接口异步抽奖
        setTimeout(() => {
          // 中奖的学生就是prizes里最后的那四个
          const index = this.prizesArray[i].length - 1
          // 调用stop停止旋转并传递中奖索引
          this.$refs['slotMachine'][i].stop(index)
        }, 3000)
        setTimeout(() => {
          this.disableSelect = false
        }, 6000)

      })

    },
    // 抽奖结束会触发end回调
    endCallback (prize) {
      console.log(prize)
    },
    /*********************老虎机相关方法end**********************/
  },
  name: "detail-interaction",
  destroyed() {
    // 页面销毁关闭定时器
    if (this.socketTimer) {
      clearInterval(this.socketTimer)
    }

    // if (this.refreshTimer) {
    //     clearInterval(this.refreshTimer)
    //     this.refreshTimer = null;
    // }

    this.disconnect();
  },

}
</script>
<style>
.startSelect {
  width: 470px;
  height: 80px;
  color: #fff;
  background: #1abc9c;
  font-size: 32px;
  text-align: center;
  line-height: 80px;
  border: 2px solid #1abc9c;
  border-radius: 80px;
}


.selectDialog {
  background: transparent!important;
  box-shadow: 0 0 0 #fff!important;
  margin-top: 0%!important;
  margin-bottom: 0!important;
}
.slick-prev:before, .slick-next:before {
  font-family: 'slick';
  font-size: 50px;
  line-height: 1;
  opacity: 0.75;
  color: #ddd;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-prev {
  left: -25px;
}
.slick-next {
  right: -25px;
}
.slick-prev, .slick-next {
  width: 50px;
  height: 50px;
  z-index: 10
}
</style>
<style lang="sass" scoped>

.interaction
  padding: 5px
  .chatBox
    border: 1px solid #efefef
    height: 500px
    overflow: auto
    .clearfix:after
      content: "\20"
      display: block
      height: 0
      clear: both
    ul
      padding: 0
      li
        list-style: none
        margin: 20px
        .avatar
          border-radius: 100%
          width: 50px
          height: 50px
          overflow: hidden
          img
            width: 50px
            height: 50px
        .content
          width: calc(100% - 70px)
          .name
            font-size: 14px
            color: #ababab
          .text
            background: #efefef
            border-radius: 8px
            padding: 8px
            display: inline-block
      li.others
        .avatar
          float: left
          margin-right: 20px
        .content
          float: left
          .text
      li.me
        .avatar
          float: right
          margin-left: 20px
        .content
          float: right
          .text
            float: right
          .name
            text-align: right
  .toolLine
    display: flex
    justify-content: space-between
    padding: 10px 0
  .enter
    margin-top: 10px

  .btn
    background: #1abc9c
    span
      color: white
  .btnBox
    float: right
    margin-top: 10px

  .currentTime
    color: #ababab

  .randomSelect
    margin-top: 10px
    text-align: center

  .answerBox
    height: 422px
    overflow: auto
    ul
      list-style: none
      margin: 0
      padding: 0
      li
        font-size: 14px
        display: flex
        justify-content: space-between
        align-items: center
        border-bottom: 1px solid #efefef
        padding: 8px 0
        .left
          width: 55%
        p
          margin: 0
          padding: 3px



  .nameCard
    border: 1px solid #efefef
    margin: 10px 0 0 0
    padding: 12px
    .person
      display: flex
      .avatar
        width: 50px
        height: 50px
        border-radius: 100%
        overflow: hidden
        img
          width: 50px
          height: 50px
      .personDetail
        margin-left: 10px
    .personDesc
      font-size: 14px
      margin-top: 12px
  .model
    border: 1px solid #efefef
    margin: 10px 0 0 0
    padding: 24px 12px

  .voteStatisticsContainer
    .votes
      height: 400px
      overflow: auto
    ul
      list-style: none
      padding: 0
      li
        margin-bottom: 10px
        p
          margin: 6px 0
        span.bar
          background: #02a7f0
          display: inline-block
          height: 10px
        span.number
          color: #02a7f0

  .answerStatisticsContainer
    .slideContainer
      width: 90%
      margin: auto
      .question
        padding: 0 40px
        box-sizing: border-box
        ul
          list-style: none
          padding: 0
          li
            margin-bottom: 10px
            p
              margin: 6px 0
            span.bar
              background: #02a7f0
              display: inline-block
              height: 10px
            span.number
              color: #02a7f0
  .awardsStatistics
    height: 200px
    overflow: auto
    ul
      list-style: none
      padding: 0
      li
        display: flex
        .name
          width: 70%
        .time
          width: 15%
        .score
          width: 15%

  .redPocketStatisticsContainer
    .question
      padding: 0 20px
      box-sizing: border-box
      ul
        list-style: none
        padding: 0
        li
          margin-bottom: 10px
          p
            margin: 6px 0
          span.bar
            background: #02a7f0
            display: inline-block
            height: 10px
          span.number
            color: #02a7f0

  .dialogContainer
    width: 100%
    display: flex
    justify-content: center

  .selectBackground
    width: 1484px
    height: 578px
  .selectBackground
    display: flex
    position: relative
    margin: auto
    .layer
      width: 1310px
      left: 90px
      top: 288px
      position: absolute
      z-index: 2
      ul
        list-style: none
        display: flex
        margin: 0
        padding: 0
        width: 1310px
        justify-content: center
        li
          width: 240px
          height: 240px
          margin-right: 30px
          background-color: #1EBC9D
          background-repeat: no-repeat
          background-position: center center
          border-radius: 20px
          &:last-child
            margin-right: 0

    .selectList
      display: flex
      top: 288px
      left: 90px
      position: absolute
      z-index: 1
      width: 1310px
      justify-content: center

    .selectBox
      width: 240px
      height: 240px
      background: #00D0A6
      margin-right: 30px
      border-radius: 20px
      overflow: hidden
      &:last-child
        margin-right: 0

      .rePick
        text-align: center
        margin-top: 10px
        color: #1abc9c
        span
          cursor: pointer

  .startPick
    margin-top: 20px
    text-align: center

  .question
    width: 50%
    margin: auto
    .questionIndex
      text-align: center
      em
        font-style: normal
        color: #02a7f0
    .groupTitle
      color: #ababab
    ul
      list-style: none
      padding: 0
      li
        margin-bottom: 10px
        p
          margin: 6px 0
        .barBox
          display: flex
          align-items: center
        span.bar
          background: #02a7f0
          display: inline-block
          height: 10px
        span.number
          color: #02a7f0
          white-space: nowrap
          margin-left: 6px
  .paging
    margin-top: 10px
    text-align: right

  .tabRight
    text-align: right
    margin-bottom: 14px
  .tabContainer

.outInteraction
  background: #fff
  height: calc(100vh)
  padding: 0 20px
  border-top: 1px solid #fff
  overflow: hidden
  .chatBox
    height: calc(100vh - 230px)
</style>

<style lang="scss" scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1abc9c;
}
/deep/ .el-tab-pane {
  display: flex;
}
/deep/ .el-tabs__item.is-active {
  color: #1abc9c;
}
/deep/ .el-tabs__item:hover {
  color: #1abc9c;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: 0;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1abc9c;
  border-color: #1abc9c;
}

/deep/ .el-checkbox__inner {
  width: 24px;
  height: 24px;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #1abc9c;
}
/deep/ .el-checkbox__inner::after {
  height: 14px;
  left: 7px;
  width: 6px;
}
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}

/deep/ .el-dialog {
  margin-top: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/offline_course/detail/interaction.vue